import { render, staticRenderFns } from "./ModalWarningAmountAdsAccount.vue?vue&type=template&id=bc67bffe&scoped=true&"
import script from "./ModalWarningAmountAdsAccount.vue?vue&type=script&lang=js&"
export * from "./ModalWarningAmountAdsAccount.vue?vue&type=script&lang=js&"
import style0 from "./ModalWarningAmountAdsAccount.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ModalWarningAmountAdsAccount.vue?vue&type=style&index=1&id=bc67bffe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc67bffe",
  null
  
)

export default component.exports